'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Validator 格式校验
 */
var validator = {
  test: function test(type, value) {
    switch (type) {
      case 'name':
        return this.isName(value);

      case 'phone':
        return this.isPhone(value);

      case 'bankcard':
        return this.isBankCard(value);

      case 'IDCard':
        return this.isIDCard(value);

      default:
        return '';
    }
  },
  // 姓名
  isName: function isName(value) {
    if (value && /^\d+$/g.test(value)) {
      return '姓名输入错误';
    }

    return '';
  },
  // 手机号
  isPhone: function isPhone(value) {
    if (!value) {
      return '';
    } else if (!/^\d{11}$/g.test(value)) {
      return '手机号为11位数字';
    } else if (!/^1\d{10}$/g.test(value)) {
      return '手机号输入错误';
    }

    return '';
  },
  // 身份证号
  isIDCard: function isIDCard(value) {
    if (!value) {
      return '';
    } else if (!/(^\d{17}(\d|X)$)|(^\d{15}$)/gi.test(value)) {
      return '身份证为15或18位数字,末位可以为X';
    } else if (/^\d{17}(\d|X)$/gi.test(value) && !isCnNewID(value)) {
      return '身份证号输入错误';
    }

    return '';
  },
  // 银行卡号
  isBankCard: function isBankCard(value) {
    value = value.replace(/\s/g, '');

    if (!value) {
      return '';
    } else if (!/^\d{12,19}$/.test(value)) {
      return '银行卡卡号为12-19位数字';
    }

    return '';
  }
};

var IDExp = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]; // 加权因子

var IDValid = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']; // 校验码

function isCnNewID(cid) {
  // 对前17位数字与权值乘积求和
  var sum = 0;

  for (var i = 0, l = cid.length; i < l - 1; i++) {
    sum += parseInt(cid.charAt(i), 10) * IDExp[i];
  } // 检验第18位是否与校验码相等


  return IDValid[sum % 11] === cid.charAt(17).toUpperCase();
}

exports.default = validator;
